












// Vue
import { defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'Modal',
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    size: {
      type: String as PropType<'xl'|'lg'|'md'|'sm'>,
      default: 'lg'
    },
    title: {
      type: String as PropType<string>,
      default: ''
    },
    hide: {
      type: Function as PropType<() => void>,
      default: () => null
    }
  }
})
